import * as Sentry from '@sentry/react'

let operationCount = 0
const sessionStart = Date.now()

export const tickOperation = () => {
  operationCount++
  Sentry.setTag('session_operation_count', operationCount)
  Sentry.setTag('session_duration_min', Math.floor((Date.now() - sessionStart) / 60_000))
}
